import {
  InstantAnswerBuilderFn,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const CarrierNotAvailable: InstantAnswerBuilderFn = (
  strictLocalize
) => ({
  titleBuilder: () => CarrierNotAvailableBuilder(strictLocalize).getTitle(),
  descriptionBuilder: () =>
    CarrierNotAvailableBuilder(strictLocalize).getDescription(),
});

const CarrierNotAvailableBuilder = (
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () =>
      strictLocalize({
        defaultMessage: "Carrier unavailable",
        description: {
          text: "Title for the answer of carrier not available issue",
        },
      }),
    getDescription: () => [
      strictLocalize({
        defaultMessage:
          "The carrier that you selected doesn’t ship to the address you’d like to ship to. You can select another carrier or choose Ship on your own.",
      }),
    ],
  };
};
